import type { ReactNode } from "react"

type Props = {
  title: string
  description?: string
  children: ReactNode
}

export function SectionCard({ title, description, children }: Props) {
  return (
    <section className="glass-card p-5 sm:p-6">
      <div className="mb-5">
        <h2 className="section-title">{title}</h2>
        {description ? <p className="mt-1 text-sm text-slate-500">{description}</p> : null}
      </div>
      {children}
    </section>
  )
}
